import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-2 px-6"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "distance_registered",
  class: "block text-sm font-medium leading-6 text-secondary"
}, "Km registreret på dag", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "m-2 hidden text-sm text-error peer-[&:not(:focus):invalid]:block" }, "Angiv en gyldig Km stand.", -1)
const _hoisted_4 = {
  key: 1,
  class: "py-2 px-6"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "addressFrom",
  class: "block text-sm font-medium leading-6 text-secondary"
}, "Fra adresse", -1)
const _hoisted_6 = {
  key: 2,
  class: "py-2 px-6"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "addressTo",
  class: "block text-sm font-medium leading-6 text-secondary"
}, "Til adresse", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              id: "distance_registered",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.kmUsed) = $event)),
              name: "distance_registered",
              type: "number",
              inputmode: "numeric",
              class: "peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 font-medium"
            }, null, 512), [
              [_vModelText, _ctx.kmUsed]
            ]),
            _hoisted_3
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              id: "addressFrom",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addressFrom) = $event)),
              name: "addressFrom",
              type: "text",
              class: "peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 font-medium"
            }, null, 512), [
              [_vModelText, _ctx.addressFrom]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              id: "addressTo",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addressTo) = $event)),
              name: "addressTo",
              type: "text",
              class: "peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 font-medium"
            }, null, 512), [
              [_vModelText, _ctx.addressTo]
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}